var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chartist',{attrs:{"ratio":"ct-chart","data":_vm.data,"options":_vm.options,"type":"Line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }